// extracted by mini-css-extract-plugin
export default {"container":"folder_container__gyCT8","folderIcon":"folder_folderIcon__NZgf5"};